<div class="dynamicContainerclass" cdkDrag>

</div>